import './menu-item-view-all-card.css';

import { IDataItem } from '../../../models/data.interface';
import { Util } from '../../../utils/util';
import { LocalizationService } from '../../../services/localization-service';

/**
 * Represents a menu item card in the "View All" section.
 */
export class MenuItemViewAllCard {
    private readonly _localizationService: LocalizationService;
    private readonly _item: IDataItem;
    private readonly _contentElement: HTMLElement;

    /**
     * Initializes a new instance of the MenuItemViewAllCard.
     * @param {IDataItem} item - The menu item data.
     * @param {Function} [onClickHandler] - The function to execute on button click.
     */
    constructor(localizationService: LocalizationService, item: IDataItem, onClickHandler?: Function) {
        this._localizationService = localizationService;
        this._item = item;
        this._contentElement = this._createElement();
        this._attachClickHandler(onClickHandler);
    }

    /**
     * Gets the HTML element representing the menu item card.
     * @returns {HTMLElement} The menu item card element.
     */
    public get element(): HTMLElement {
        return this._contentElement;
    }

    /**
     * Creates the HTML element for the menu item card.
     * @returns {HTMLElement} The created menu item card element.
     */
    private _createElement(): HTMLElement {
        const name = this._localizationService.GetName(this._item.Names);
        const description = this._localizationService.GetDescription(this._item.Descriptions);

        const html = `
            <div id="div_menu_item_view_all_${this._item.ItemId}" class="menu-item-view-all-card" data-id="${this._item.ItemId}">
                <div class="menu-item-view-all-card__image-container">
                    ${(this._item.ImageURL && this._item.ImageURL.trim() != "") ? `<img class="menu-item-view-all-card__image" src="${this._item.ImageURL}" alt="${name}">` : ""}
                </div>
                <div class="menu-item-view-all-card__label-container">
                    <h3 class="menu-item-view-all-card__label" ltagj="${Util.toLtagj(this._item.Names)}">${name}</h3>
                    <span class="menu-item-view-all-card__label-desc" ltagj="${Util.toLtagj(this._item.Descriptions)}">${description}</span>
                </div>
                 <div class="menu-item-view-all-card__button-container">
                    <button id="btn_menu_item_view_all_${this._item.ItemId}" class="secondary" ltag="Customize">${this._localizationService.names("Customize")}</button>
                </div>
            </div>`;

        return Util.createHtmlElementFromTemplate(html);
    }

    /**
    * Attaches a click handler to the customize button.
    * @param {Function} [onClickHandler] - The function to execute on button click.
    */
    private _attachClickHandler(onClickHandler?: Function): void {
        if (!onClickHandler)
            return;

        const button = this._contentElement.querySelector(`#btn_menu_item_view_all_${this._item.ItemId}`);
        if (button)
            Util.setElement("onclick", (button as HTMLElement), onClickHandler);
    }
}